import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { baseGraphqlUrl } from "./config";
import { getAuthenticationToken } from "./SessionStorage";

const httpLink = createHttpLink({
  uri: baseGraphqlUrl,
});

const authLink = setContext((_, { headers }) => {
  const token = getAuthenticationToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
